// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__Iaa7b","disabled":"FileBtn_disabled__ikvmO","warn":"FileBtn_warn__J9tzW","fade":"FileBtn_fade__loa5v"};